import styled from "styled-components"
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css'
import { useMediaQuery } from "react-responsive";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
// import { Navigation } from 'swiper/modules';
import 'swiper/css/autoplay';
import en from '../images/en.png'
import it from '../images/it.png'
import nl from '../images/nl.png'
import au from '../images/au.png'
import ru from '../images/ru.png'
import ie from '../images/ie.png'
import { Autoplay, Pagination } from "swiper/modules";
import "swiper/css/pagination";

const Reviews = () => {
    const isMobile = useMediaQuery({ query: '(max-width: 668px)' });
    const [numSlides, setNumSlides] = useState(0);
    const { t } = useTranslation();
    
    const reviews = [
        {
            id : 1,
            vote : "10",
            name : "Livia",
            place : "italia",
            icon : it,
            description : "recensione1"
        },
        {
            id : 2,
            vote : "9.0",
            name : "Nordin",
            place : "paesiBassi",
            icon : nl,
            description : "recensione2"
        },
        {
            id : 3,
            vote : "10",
            name : "Elizabeth",
            place : "italia",
            icon : it,
            description : "recensione3"
        },
        {
            id : 4,
            vote : "10",
            name : "Gordon",
            place : "australia",
            icon : au,
            description : "recensione4"
        },
        {
            id : 5,
            vote : "10",
            name : "Linda",
            place : "regnoUnito",
            icon : en,
            description : "recensione5"
        },
        {
            id : 6,
            vote : "8.0",
            name : "Linda",
            place : "paesiBassi",
            icon : nl,
            description : "recensione6"
        },
        {
            id : 7,
            vote : "9.0",
            name : "Carole",
            place : "regnoUnito",
            icon : en,
            description : "recensione7"
        },
        {
            id : 8,
            vote : "10",
            name : "Dmitri",
            place : "russia",
            icon : ru,
            description : "recensione8"
        },
        {
            id : 9,
            vote : "9.0",
            name : "Robmcglan",
            place : "irlanda",
            icon : ie,
            description : "recensione9"
        },
        {
            id : 10,
            vote : "9.0",
            name : "Lauren",
            place : "regnoUnito",
            icon : en,
            description : "recensione10"
        },
    ]

    useEffect(()=> {
        if (isMobile) {
            setNumSlides(1)
        } else {
            setNumSlides(3)
        }
    }, [isMobile, numSlides])
    
    return (
    <Wrapper>
        <div className="container" style={isMobile ? {maxWidth: '100%'} : null}>
            <div className="title"> 
                <h3>{t('recensioniDegliOspiti')}</h3>
            </div>
            <Swiper
                style={{paddingBottom: '50px'}}
                // spaceBetween={20}
                slidesPerView={numSlides}
                pagination={{ clickable: true }}
                // onSlideChange={() => console.log('slide change')}
                // onSwiper={(swiper) => console.log(swiper)}
                modules={[Autoplay, Pagination]} 
                autoplay={{
                    delay: 8000,
                    // disableOnInteraction: false,
                 }}
            >
                {
                    reviews.map((review) => {
                        return <SwiperSlide key={review.id} className="box">
                            <div className="card">
                                <div className="header">
                                    <div className="left">
                                        <div className="logo">
                                            <span>{review.name[0]}</span>
                                        </div>
                                        <div className="info">
                                            <div className="name">{review.name}</div>
                                            <div className="place">
                                                <img src={review.icon} alt="" />
                                                <span>{t(review.place)}</span>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="right">
                                        <span>{review.vote}</span>
                                    </div>
                                </div>
                                <div className="description">
                                    {t(review.description)}
                                </div>
                            </div>
                        </SwiperSlide>
                    })
                }
            </Swiper>
        </div>
    </Wrapper>
  )
}

export default Reviews


const Wrapper = styled.section`
    .container {
        /* margin: 45px 0px 30px 0px; */
        .title {
            display: flex;
            justify-content: center;
            h3 {
            display: inline-block;
            padding-right: 5px;
            /* padding-bottom: 5px; */
            margin: 0px 0px 50px 0px;
            font-size: 25px;
            color: var(--logo);
            text-transform: uppercase;
            border-bottom: 2px solid var(--logo);
        }
        }
        padding: 50px 0px;
        .box {
            display: flex;
            justify-content: center;
            align-items: center;
        }
        .card {
            background-color: var(--gray);
            border-radius: 10px;
            height: 90%;
            width: 90%;
            padding: 25px;
            .header {
                display: flex;
                justify-content: space-between;
                align-items: center;
                margin-bottom: 5px;
                .left {
                    display: flex;
                    align-items: center;
                    justify-content: flex-start;
                    .logo {
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        padding-right: 5px;
                        span {
                            display: flex;
                            justify-content: center;
                            align-items: center;
                            border-radius: 50%;
                            padding: 5px;
                            background-color: var(--footer);
                            color: white;
                            /* font-weight: bold; */
                            height: 30px;
                            width: 30px;
                            margin-right: 3px;
                        }
                    }
                    .info {
                        .name {
                            font-size: 14px;
                            font-weight: bold;
                        }
                        .place {
                            display: flex;
                            justify-content: flex-start;
                            align-items: center;
                            img {
                                display: inline-block;
                                width: 12px;
                                height: 12px;
                                margin-right: 5px;
                            }
                            font-size: 12px;
                        }
                    }
                }
                .right {
                    span {
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        width: 30px;
                        height: 30px;
                        background-color: #003B95;
                        border-bottom-right-radius: 5px;
                        border-top-right-radius: 5px;
                        border-top-left-radius: 5px;
                        color: white;
                    }
                }
            }
                .description {
                    padding: 10px 5px 0px;
                    font-size: 12px;
                }
        }
    }
`
